export default __webpack_public_path__ + "static/media/right_bottom_image_desktop.d0d5ac95.png";